var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBBillGbp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-bill-GBP",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-bill-GBP1",
    serifid: "iconB-bill-GBP",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M-0.011,18.727l-0,-12.504c0.001,-0.993 0.806,-1.798 1.799,-1.8c0.016,0 0.033,0.001 0.049,0.003c-0,0 2.073,0.236 3.727,0.236c2.027,0 7.183,-1.423 10.773,-1.481c2.009,-0.032 5.56,0.274 5.888,0.302l0.012,0.001c0.981,0.014 1.773,0.814 1.774,1.799l0,12.505c-0.001,0.993 -0.806,1.798 -1.799,1.799c-0.016,0 -0.033,-0.001 -0.049,-0.002c0,-0 -2.073,-0.237 -3.727,-0.237c-2.027,0 -7.183,1.424 -10.773,1.481c-2.009,0.033 -5.56,-0.273 -5.888,-0.302l-0.012,-0c-0.981,-0.015 -1.773,-0.815 -1.774,-1.8Zm21.994,-1.195l-0,-12.038c-0.789,-0.067 -3.837,-0.313 -5.633,-0.284c-3.593,0.058 -8.757,1.481 -10.786,1.481c-1.327,-0 -2.917,-0.148 -3.547,-0.212l0,12.038c0.789,0.067 3.837,0.313 5.633,0.284c3.593,-0.058 8.757,-1.481 10.786,-1.481c1.327,-0 2.917,0.148 3.547,0.212Zm-14.983,-5.532c-0,0.828 -0.672,1.5 -1.5,1.5c-0.828,-0 -1.5,-0.672 -1.5,-1.5c-0,-0.828 0.672,-1.5 1.5,-1.5c0.828,-0 1.5,0.672 1.5,1.5Zm2.939,1.418c-0.605,-0 -1.095,-0.49 -1.095,-1.095c0,-0.534 0.385,-0.98 0.893,-1.075c-0.158,-0.344 -0.272,-0.727 -0.278,-1.212l-0,-0.016c-0,-1.651 1.039,-2.443 2.272,-2.647c1.07,-0.178 2.287,0.186 2.92,0.756c0.45,0.404 0.486,1.096 0.082,1.546c-0.405,0.449 -1.097,0.485 -1.546,0.082c-0.235,-0.212 -0.7,-0.291 -1.097,-0.225c-0.231,0.039 -0.439,0.175 -0.442,0.487c0.01,0.375 0.228,0.585 0.366,0.841c0.063,0.119 0.123,0.242 0.176,0.369l1.185,0c0.603,0 1.094,0.491 1.094,1.094c0,0.605 -0.491,1.095 -1.094,1.095l-1.099,-0c-0.09,0.38 -0.218,0.738 -0.363,1.065l2.148,-0c0.605,-0 1.096,0.491 1.096,1.094c0,0.605 -0.491,1.095 -1.096,1.095l-4.122,0c-0.438,0 -0.831,-0.259 -1.005,-0.659c-0.173,-0.4 -0.092,-0.866 0.206,-1.185c0,-0 0.549,-0.577 0.864,-1.41l-0.065,-0Zm10.061,-1.418c-0,0.828 -0.672,1.5 -1.5,1.5c-0.828,-0 -1.5,-0.672 -1.5,-1.5c-0,-0.828 0.672,-1.5 1.5,-1.5c0.828,-0 1.5,0.672 1.5,1.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBBillGbp);
export default __webpack_public_path__ + "static/media/iconB-bill-GBP.9147385377c893de32b83919094acdb1.svg";
export { ForwardRef as ReactComponent };